<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import dbjgmx from "./dbjgmx/index.vue";
import {
    queryCompanyShuibDict,
} from '../../../../api/Draftgeneration.js';
import {
    contrastResultPageQuery
} from '../../../../api/contrastSetting.js';
export default {
    components: { dbjgmx },
    name: 'sbbdsz',
    data: function() {
        return {
            tablekey: 0,
            overlength: 0,
            searchdata: getdata().searchdata,
            searchlist: getdata().searchlist,
            filterSearchlist: [],
            outlist: [],
            headData: getdata().headData,
            pagination: getdata().pagination,
            suosq: this.$getdefultMonth(),
            tableData: [],
            searchdiag: false,
            shuizFormat: [],
            mxdiag: false,
            mxid: "",
            mxShuizId: "",
            mxShuizName: "",
        };
    },
    mounted() {
    },
    created() {
        this.init();
    },
    methods: {
        geOoverLength(e) {
            this.overlength = e;
        },
        setDetailView(e) {
            this.mxdiag = true;
            this.mxid = e.id.toString();
            this.mxShuizId = e.shuizId.toString();
            this.mxShuizName = e.reportName;
        },
        //初始化
        init() {
            this.getShuizList();
            this.contrastResultQuery();
        },
        suosqchange() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.tablekey++;
            this.contrastResultQuery();
        },
        contrastResultQuery() {
            let params = JSON.parse(JSON.stringify(this.searchdata));
            params.current = this.pagination.pageNum;
            params.size = this.pagination.pageSize;
            params.shenbq = this.suosq;
            contrastResultPageQuery(params).then(res => {
                this.pagination.total = res.data.data.total;
                this.tableData = res.data.data.records;
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.checked = false;
                let newarr = JSON.parse(JSON.stringify(this.tableData));
                this.tableData = newarr;
            });
        },
        getShuizList() {
            queryCompanyShuibDict().then(res => {
                this.searchlist.forEach(item => {
                    if (item.prop == 'shuizId') {
                        item.selectval = res.data.data.map(item => {
                            return {
                                label: item.reportName,
                                value: item.id
                            };
                        });
                        this.shuizFormat = item.selectval;
                    }
                });
                let newarr = JSON.parse(JSON.stringify(this.searchlist));
                this.searchlist = newarr;
            });
        },
        sizechange(e) {
            this.pagination.pageSize = e;
            this.contrastResultQuery();
        },
        currentChange(e) {
            this.pagination.pageNum = e;
            this.contrastResultQuery();
        },
        submitSearch() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.contrastResultQuery();
        },
        forRefresh() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
        },
        forUpdateSearch() {
            this.filterSearchlist = JSON.parse(JSON.stringify(this.filterSearchlist.length ? this.filterSearchlist : this.searchlist));
            this.searchdiag = true;
        },
        closeSearch() {
            this.searchdiag = false;
        },
        saveChange(e) {
            this.filterSearchlist = e;
            this.searchlist = e.filter(item => item.isshow);
            this.searchdiag = false;
        },
        confirmfilter(e) {
            this.headData = e.chooselist;
            this.outlist = e.nochooselist;
        },
        forback() {
            this.pagination.pageNum = 1;
            this.pagination.paginationkey++;
            this.contrastResultQuery();
            this.ywgzpg = false;
        },
        closediag() {
            this.setdiag = false;
            this.contrastResultQuery();
        }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
